import env from '@/env';

export function toList(value) {
  if (value.type === 3) {
    value.type = 1;
  }
  if (value.firstDocId && value.firstDocCategoryIds) {
    return `${env.ACORE_DOMAIN}/help/list/${value.id}?type=${value.type}&categoryIds=${value.categoryIds}&firstDocId=${value.firstDocId}&firstDocCategoryIds=${value.firstDocCategoryIds}`;
  } else {
    return `${env.ACORE_DOMAIN}/help/list/${value.id}?type=${value.type}&categoryIds=${value.categoryIds}`;
  }
}

export function toListMore() {
  return `${env.ACORE_DOMAIN}/help`;
}

export const scrollToTop = (targetTop, scrollPace = 10, cb = null) => {
  const currentY = document.body.scrollTop || document.documentElement.scrollTop;
  scrollAnimation(currentY, targetTop, scrollPace);
  // 实现滚动上去的动画效果
  function scrollAnimation(currentY, targetY, pace) {
    const needScrollTop = targetY - currentY;
    let _currentY = currentY;
    setTimeout(() => {
      const dist = Math.ceil(needScrollTop / pace);
      _currentY += dist;
      window.scrollTo(0, currentY);
      if (needScrollTop > 10 || needScrollTop < -10) {
        scrollAnimation(_currentY, targetY, pace);
      } else {
        window.scrollTo(0, targetY);
        cb && cb();
      }
    }, 5);
  }
};
